export const getFaqSchool = (data) => {
  const {
    schoolName, city, street, zipcode, phone, avgRating, reviewsNumber, examStatLicenseB, numberOfStudentB, examStatYear, licenseCategories, licenseTags, hasTimetable,
  } = data;

  const questions = [
    {
      id: 'faq-school-1',
      question: `Quel est le numéro de téléphone de ${schoolName}?`,
      answer:
        phone
          ? `Vous pouvez appeler ${schoolName} au ${phone} pendant les horaires d’ouverture.`
          : 'L’auto-école n’a pas renseigné son numéro de téléphone.',
    },
    {
      id: 'faq-school-2',
      question: `Quelle est l’adresse de ${schoolName}?`,
      answer: `L’auto-école est située au ${street} ${zipcode} ${city}.`,
    },
    {
      id: 'faq-school-4',
      question: `Comment prendre rendez-vous avec ${schoolName}?`,
      answer:
        `Vous pouvez <a href="${window.location.href.split(/[?#]/)[0]}#rdv" target="_blank" rel="noopener noreferrer">prendre rendez-vous</a> avec ${schoolName} pour des renseignements ou une inscription. Important, ce formulaire ne permet pas de réserver une leçon de conduite. En cas de doute, appelez l’auto-école au ${phone}.`,
    },
    {
      id: 'faq-school-5',
      question: `Quels sont les avis des anciens élèves sur ${schoolName}?`,
      answer:
        `L’auto-école a une note moyenne de ${avgRating}/5 sur un nombre total de ${reviewsNumber}. Consultez en priorité les « avis vérifiés » pour lesquels un justificatif d’inscription a été envoyé.`,
    },
    {
      id: 'faq-school-6',
      question: `Quel est le taux de réussite de ${schoolName}?`,
      answer:
        `L’auto-école a un taux de réussite de ${examStatLicenseB} % sur ${numberOfStudentB} candidats pour l’année ${examStatYear}. Il s’agit des taux de réussite officiels transmis par le Ministère de l’Intérieur. Important, les taux de réussite doivent être pris avec précaution. Avant de vous inscrire dans une auto-école, il est préférable de consulter les avis et de vous rendre sur place afin de vous faire une opinion par vous-même.`,
    },
    {
      id: 'faq-school-7',
      question: `Quelles sont les formations proposées par ${schoolName}?`,
      answer:
        licenseCategories.length || licenseTags.length
          ? `L’auto-école propose des formations au : ${licenseCategories.join(', ')}${licenseCategories.length && licenseTags.length ? ', ' : ''}${licenseTags.join(', ')}.`
          : 'L’auto-école n’a pas renseigné les formations qu’elle dispense.',
    },
  ];

  if (hasTimetable) {
    const workingHours = {
      id: 'faq-school-3',
      question: `Quels sont les horaires de ${schoolName}?`,
      answer:
        'Les horaires de l’auto-école sont <a href="#horaires">consultable ici</a>. Il est préférable de téléphoner avant de vous déplacer.',
    };

    questions.splice(2, 0, workingHours);
  }

  return ({
    title: 'Questions fréquentes',
    sections: [
      {
        questions,
      },
    ],
  });
};
